import {
  ApiBlueprint,
  createFrontendModule,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { KnowledgeClient, knowledgeApiRef } from './api';
import { knowledgeBuilderFieldExtension } from './extensions/knowledgeBuilderField';

const knowledgeApiExtension = ApiBlueprint.make({
  name: 'knowledge',
  params: defineParams =>
    defineParams({
      api: knowledgeApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new KnowledgeClient({ discoveryApi, fetchApi }),
    }),
});

export const knowledgeScaffolderModule = createFrontendModule({
  pluginId: 'scaffolder',
  extensions: [knowledgeApiExtension, knowledgeBuilderFieldExtension],
});
